'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var bumbag = require('bumbag');
var faSpinnerThird = require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
var reactFontawesome = require('@fortawesome/react-fontawesome');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var WithLoadingIndicator = function WithLoadingIndicator(_ref) {
  var _clsx;

  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive;
  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, isActive ? /*#__PURE__*/React__default["default"].createElement(bumbag.Box, {
    "data-testid": "loading",
    textAlign: "center",
    className: clsx.clsx((_clsx = {}, _clsx[className || ''] = Boolean(className), _clsx))
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faSpinnerThird.faSpinnerThird,
    size: "2x",
    className: "text-primary-base animate-spin"
  }), ' ') : children);
};

WithLoadingIndicator.defaultProps = {
  children: null,
  className: null
};

exports["default"] = WithLoadingIndicator;
